import { useMemo } from "react"
import {
  Progress,
  Typography,
  Space,
  CheckCircleFilled,
  CloseCircleFilled,
} from "@mimber/ui-web"
import {
  PASSWORD_VALIDATIONS,
  getStrengthConfig,
} from "./PasswordStrengthMeter.utils"
import type { PasswordStrengthMeterProps } from "./PasswordStrengthMeter.types"

const { Text } = Typography

export const PasswordStrengthMeter: React.FunctionComponent<
  PasswordStrengthMeterProps
> = ({ password }) => {
  const results = useMemo(
    () =>
      PASSWORD_VALIDATIONS.map((rule) => ({
        ...rule,
        passed: password.length > 0 && rule.validate(password),
      })),
    [password]
  )

  const passedCount = results.filter((r) => r.passed).length
  const percent = (passedCount / PASSWORD_VALIDATIONS.length) * 100
  const config = getStrengthConfig(passedCount)

  return (
    <Space orientation="vertical" size="small" className="w-full mb-4">
      <Progress
        percent={percent}
        strokeColor={config.color}
        showInfo={false}
        size="small"
      />
      <Text type="secondary" style={{ fontSize: 12 }}>
        {config.label}
      </Text>
      <Space orientation="vertical" size={2}>
        {results.map((rule) => (
          <Space key={rule.label} size="small">
            {rule.passed ? (
              <CheckCircleFilled style={{ color: "#52c41a", fontSize: 14 }} />
            ) : (
              <CloseCircleFilled style={{ color: "#d9d9d9", fontSize: 14 }} />
            )}
            <Text
              type={rule.passed ? undefined : "secondary"}
              style={{ fontSize: 13 }}
            >
              {rule.label}
            </Text>
          </Space>
        ))}
      </Space>
    </Space>
  )
}
